module.exports = __webpack_public_path__ + "static/media/referente.f5b528ab.svg";